<template>
  <div class="w-100">
    <div class="row slim-grid-row">
      <div class="col-8">
        <div class="w-100 position-relative border-form radius-6" :class="{
          'shake-el border-warning': error != ''
        }">
          <input 
            :disabled="is_load"
            type="text" 
            class="p-3 body-2-1 w-100 no-focus-border border-none radius-6" 
            v-model="form" @keyup.enter="$refs.btn_promo.handleClick()" >
          <div v-if="form != ''" class="position-absolute cursor-pointer" @click="clearPromoCode" style="top: 10px;right:10px;">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.221622 13.3683C0.521384 13.6596 1.01813 13.6596 1.30933 13.3683L6.7907 7.88694L12.2721 13.3683C12.5633 13.6596 13.0686 13.6681 13.3598 13.3683C13.651 13.0686 13.651 12.5804 13.3598 12.2892L7.87841 6.79924L13.3598 1.31787C13.651 1.02667 13.6596 0.529924 13.3598 0.238726C13.06 -0.0610364 12.5633 -0.0610364 12.2721 0.238726L6.7907 5.7201L1.30933 0.238726C1.01813 -0.0610364 0.512819 -0.069601 0.221622 0.238726C-0.0695761 0.538488 -0.0695761 1.02667 0.221622 1.31787L5.70299 6.79924L0.221622 12.2892C-0.0695761 12.5804 -0.078141 13.0771 0.221622 13.3683Z"
                fill="#777777" />
            </svg>
          </div>
        </div>
      </div>
      <div class="col-4">
        <state-button ref="btn_promo" block variant="primary" size="lg" :click="applyPromo" :disabled="is_load">Apply</state-button>
      </div>
      <div class="col-12 mt-1">
        <p class="w-100 mb-0 body-3 text-warning" v-if="error != ''">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { get } from '@/services/index.js'
  import { mapGetters,mapMutations } from 'vuex'

  export default {
    props:['general_data'],
    data() {
      return {
        form: '',
        error: '',
        is_load: false,
        valid: '',

      }
    },
    computed:{
      ...mapGetters(['getMerchant','getOutletTrxProducts','getOutletTrxPromoCode']),
    },
    mounted(){
      this.form = this.getOutletTrxPromoCode
      if(this.getOutletTrxPromoCode != ''){
        setTimeout(() => {
          this.$refs.btn_promo.handleClick()
        }, 100);
      }
    },
    methods:{
      ...mapMutations(['setTrxOutletPromoCode','updateTrxOutletProductPricing','restoreTrxOutletProduct','restoreTrxOutletPricePerProduct']),
      applyPromo(){
        return new Promise((success,fail)=>{
          if(this.form == '' && !is_clear){
            this.error = 'Promo code is empty'
            success()
          }else{
            this.is_load = true
            this.error = ''
            this.loadProduct()
            .then(res=>{
              this.validateProductWithPromo(res).finally(()=>{
                this.is_load = false
                success()
              })
            })
            .catch(err=>{
              this.error = err == 'promo_code not found' ? 'Promo code not available' : err
              this.is_load = false
              fail()
            })
          }
        })
      },
      clearPromoCode(){
        if(!this.is_load){
          this.error = ''
          this.form = ''
          if(this.getOutletTrxPromoCode != ''){
            this.is_load = true
            let current_promo_code = this.getOutletTrxPromoCode
            let checkIfPromoSame = (data) => {
              let is_got_promo = data.best != null
              let is_promo_code = is_got_promo && data.best.promotion_type == 'PROMO_CODE'
              let is_promo_code_same = is_promo_code && data.best.promo_code == current_promo_code
              return is_promo_code_same
            } 
            
            this.getOutletTrxProducts.forEach((item,index)=>{
              let is_variant = item.variants.length > 0
              if(is_variant){
                let is_variant_same_code = item.variants.some(x=>checkIfPromoSame(x.temp_variant_data.promotion_affected))
                if(is_variant_same_code){
                  this.loadProductDetail(item.product_data.id).then(res=>{
                    item.variants.forEach(variant => {
                      let params = {
                        product: item.product_data,
                        variant: variant.variant_data,
                        action: 'restore'
                      }
                      let is_promo_same = checkIfPromoSame(variant.temp_variant_data.promotion_affected)
                      if(checkIfPromoSame(variant.temp_variant_data.promotion_affected)){
                        params.action = 'renew'
                        let variant_i = res.variant_list.findIndex(x=>x.id == variant.variant_data.id)
                        params.variant = res.variant_list[variant_i]
                        this.restoreTrxOutletPricePerProduct(params)
                      }else{
                        this.restoreTrxOutletPricePerProduct(params)
                      }
                    })
                  }).catch(err=>{
                    console.log(`Error from API (${item.product_data.name}) :`, err)
                  })
                }else{
                  item.variants.forEach(variant => {
                    let params = {
                      product: item.product_data,
                      variant: variant.variant_data,
                      action: 'restore'
                    }
                    this.restoreTrxOutletPricePerProduct(params)
                  })
                }
              }else{
                let params = {
                  product: item.product_data,
                  variant: {},
                  action: 'restore'
                }
                if(checkIfPromoSame(item.temp_product_data.promotion_affected)){
                  this.loadProductDetail(item.product_data.id).then(res=>{
                    params.action = 'renew'
                    params.product = res
                    this.restoreTrxOutletPricePerProduct(params)
                  }).catch(err=>{
                    console.log(`Error from API (${item.product_data.name}) :`, err)
                  })
                }else{
                  this.restoreTrxOutletPricePerProduct(params)
                }
              }

              if(index+1 == this.getOutletTrxProducts.length){
                setTimeout(() => {
                  this.setTrxOutletPromoCode('')
                  this.is_load = false
                }, 300);
              }
            })
          }
        }
      },
      validateProductWithPromo(product_list){
        return new Promise((done)=>{
          let copied_products = this.$deepCopy(product_list)
          let product_affected = copied_products.filter(product=>{
            let is_variant = product.variant_list.length > 0
            let checkPromo = (promotion_affected) => {
              if(promotion_affected.best != null && promotion_affected.best.promotion_type == 'PROMO_CODE' && promotion_affected.best.promo_code == this.form) return product
              else return false
            }
            
            if(is_variant){
              let total_variant_affected = 0
              for (let i = 0; i < product.variant_list.length; i++) {
                const variant = product.variant_list[i];
                let promo_result = checkPromo(variant.promotion_affected)
                if(promo_result) total_variant_affected++
                if(i+1 == product.variant_list.length){
                  return total_variant_affected > 0 ? true : false
                }
              }
            }else{
              return checkPromo(product.promotion_affected)
            }
          })
          if(product_affected.length > 0){
            done()
            let is_cart_have_promo = this.getOutletTrxProducts.some(v_product=>{
              let is_get_promo = product_affected.some(product=> product.id == v_product.product_data.id)
              if(is_get_promo)return true
              return false
            })
  
            if(is_cart_have_promo){
              this.getOutletTrxProducts.forEach((product,product_i)=>{
                let is_product_match = product_affected.findIndex(x=>x.id == product.product_data.id)
                let product_selected = product_affected[is_product_match]
                if(is_product_match != -1){
                  let is_variant = product.variants.length > 0
                  if(is_variant){
                    product.variants.forEach((variant,variant_i)=>{
                      let is_variant_match = product_selected.variant_list.findIndex(x=>x.id == variant.variant_data.id)
                      if(is_variant_match != -1){
                        let params = {
                          product: product_selected,
                          variant: product_selected.variant_list[is_variant_match]
                        }
                        this.updateTrxOutletProductPricing(params)
                      }
                    })
                  }else{
                    let params = {
                      product: product_selected,
                      variant: {}
                    }
                    this.updateTrxOutletProductPricing(params)
                  }
                }

                if(product_i+1 == this.getOutletTrxProducts.length){
                  this.setTrxOutletPromoCode(this.form)
                  done()
                }
              })
            }else{
              this.error = 'Sorry, this promo has no effect on the product you chose'  
              done()
            }
          }else{
            this.error = 'Promo code not available'
            done()
          }
        })
      },
      loadProduct(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL", `merchant-pos/${this.general_data.id}/product`, {
            merchant_id: this.getMerchant.id,
            promo_code: this.form,
            page_size: 1000
          }).then(response => {
            let res = response.data
            if (res.success) {
              success(res.data)
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadProductDetail(product_id){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL", `merchant-pos/${this.general_data.id}/product/${product_id}`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              success(res.data)
            } else {
              fail(res.message)
            }
          })
        })
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/PromoCode.vue